// removed by extract-text-webpack-plugin
module.exports = {"container":"FullscreenLoader__container__1H3bK","darkerBackground":"FullscreenLoader__darkerBackground__3WKi8","transparentBackground":"FullscreenLoader__transparentBackground__2h0R0","preloader":"FullscreenLoader__preloader__3US1W","loader":"FullscreenLoader__loader__3GvQf","spin":"FullscreenLoader__spin__gOwbp","message":"FullscreenLoader__message__1-Fve"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/FullscreenLoader/FullscreenLoader.css
// module id = 508
// module chunks = 0